/**
 * Getters for Vuex
 */

// Private getters, only available within the store itself
// const privateGetters = {};

// PUblic getters, available within store and Vue Components
const publicGetters = {
    CURRENT_LANG: "CURRENT_LANG",
    LANGUAGES: "LANGUAGES",
    LANG_CODE: "LANG_CODE",
    I18N: "I18N",
    SCROLL_PERCENT: "SCROLL_PERCENT",
    SHOW_LANGUAGE_MENU: "SHOW_LANGUAGE_MENU",
    VISIBLE_HEIGHT: "VISIBLE_HEIGHT"
};

// Getters
const getters = {
    [publicGetters.CURRENT_LANG](state) {
        const activeLanguage = state.languages.find(lang => lang.active);
        return activeLanguage || null;
    },
    [publicGetters.LANGUAGES](state) {
        return state.languages;
    },
    [publicGetters.LANG_CODE](state) {
        return state.languages.find(lang => lang.active).code || null;
    },
    [publicGetters.I18N](state, gttrs) {
        return state.i18n[gttrs.LANG_CODE];
    },
    [publicGetters.SCROLL_PERCENT](state) {
        return (state.viewport.scrolled / (state.viewport.height - state.viewport.visible)) * 100;
    },
    [publicGetters.SHOW_LANGUAGE_MENU](state) {
        return state.showLanguageMenu;
    },
    [publicGetters.VISIBLE_HEIGHT](state) {
        return {
            min: state.viewport.scrolled,
            max: state.viewport.scrolled + state.viewport.visible,
            center: state.viewport.scrolled + (state.viewport.visible / 2),
            height: state.viewport.visible
        }
    }
};

export {
    getters as default,
    publicGetters
}